
import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import { ReadingFormValues } from "./types";

type ReadingValueFieldProps = {
  control: Control<ReadingFormValues>;
};

export const ReadingValueField = ({ control }: ReadingValueFieldProps) => {
  return (
    <FormField
      control={control}
      name="reading"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Valor de la Lectura</FormLabel>
          <FormControl>
            <Input 
              type="number" 
              placeholder="Ingrese el valor"
              value={field.value === undefined ? '' : field.value}
              onChange={(e) => field.onChange(e.target.value === '' ? undefined : Number(e.target.value))}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
